'use client';
import React, { useState, useEffect } from 'react';
import { ImageGallery as SharedImageGallery } from '@launchstore/shared-puck';
import type { ImageGalleryProps } from '@launchstore/shared-puck';
import { useProduct } from '@/lib/hooks/useProduct';
import type { ProductDataImage } from '@launchstore/shared-puck';

const SharedImageGalleryRender = (SharedImageGallery as any).render;

const ImageGalleryImpl: React.FC<ImageGalleryProps> = (props: any) => {
  const { product } = useProduct() as any;
  const images: ProductDataImage[] = (product?.images || []).map((img: any, i: number) => ({
    id: img.id || String(i),
    url: img.url,
    alt: img.alt || `${product?.title || 'Product'} - Image ${i + 1}`,
  }));
  return <SharedImageGalleryRender {...(props as any)} images={images} productTitle={product?.title} />;
};

export const ImageGallery: any = { ...SharedImageGallery, render: (props: any) => <ImageGalleryImpl {...props} /> };
export default ImageGallery;
